<template>
<div class="chapter">
<div class="inner_page">
<h1 class="h10"><span class="th11">Mission Mistletoe</span></h1>
<p class="p1"> </p>
<p class="p1"> </p>
<p class="p1">By Jessica Payseur</p>
<p class="p1"> </p>
<p class="p2">Captain Archer Pfeil’s current assignment has been nothing but one long string of disasters. As if being dumped right before Christmas wasn’t enough, the mounting misfortunes indicate he’ll be out of a job by the end of his mission.</p>
<p class="p2">But it’s difficult to salvage the assignment with Ambassador Ilin a’dlen Jhex around, pushing all Archer’s buttons. He struggles to keep his distance from the out-of-bounds ambassador, but Jhex has other plans in mind….</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 002.vue?031e5259